import React from 'react';
import { Brush, Code2, Files, Globe2, Image, Plus } from 'lucide-react';

import { cn } from '@/lib/utils';

export type BuilderRailAction = 'add' | 'pages' | 'design' | 'media' | 'site' | 'developer';

const ACTIONS: Array<{ id: BuilderRailAction; label: string; icon: typeof Plus }> = [
  { id: 'add', label: 'Toevoegen', icon: Plus },
  { id: 'pages', label: "Pagina's", icon: Files },
  { id: 'design', label: 'Ontwerp', icon: Brush },
  { id: 'media', label: 'Media', icon: Image },
  { id: 'site', label: 'Website', icon: Globe2 },
  { id: 'developer', label: 'Developer', icon: Code2 },
];

export function BuilderActionRail({ active, onAction, showDeveloper = false }: { active: BuilderRailAction | null; onAction: (action: BuilderRailAction) => void; showDeveloper?: boolean }) {
  return (
    <nav aria-label="Builderacties" className="flex w-[4.25rem] shrink-0 flex-col items-center border-r border-slate-200 bg-white px-2 py-3">
      <div className="flex w-full flex-col gap-1.5">
        {ACTIONS.filter(({ id }) => id !== 'developer' || showDeveloper).map(({ id, label, icon: Icon }) => (
          <button
            key={id}
            type="button"
            onClick={() => onAction(id)}
            aria-pressed={active === id}
            title={label}
            className={cn(
              'flex min-h-[3.5rem] w-full flex-col items-center justify-center gap-1 rounded-xl px-1 text-[10px] font-semibold transition',
              active === id ? 'bg-teal-50 text-teal-800 ring-1 ring-inset ring-teal-200' : 'text-slate-500 hover:bg-slate-50 hover:text-slate-900',
            )}
          >
            <Icon className="h-5 w-5" strokeWidth={1.8} />
            <span>{label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
}
